/**
 * Created by Ning Jiang on 2/7/2018.
 */

import { ILayerConfig, ILayersConfig } from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import { IDeviceDependentConfig } from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {
    CustomLayerScaleOptions,
    LayerScaleOption,
    ScaleMethod,
    ScaleTarget
} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";

export interface IBarbarianFuryLayerConfig extends ILayersConfig {
    readonly BACKGROUND: ILayerConfig;
    readonly REEL_BACKGROUND: ILayerConfig;
    readonly REEL_ATTENTION: ILayerConfig;
    readonly BET_LINES: ILayerConfig;
    readonly WIN_PRESENTATIONS: ILayerConfig,
    // readonly WIN_FIELD:ILayerConfig;
    readonly FOREGROUND: ILayerConfig,
    readonly REEL_FOREGROUND: ILayerConfig,
    readonly INDIVIDUAL_WIN_SYM_COMB:ILayerConfig,
    readonly BIG_WIN: ILayerConfig;
    readonly BIG_WIN_LABEL: ILayerConfig;
    readonly WIN_COUNT_UP: ILayerConfig;
    readonly SNOW_FALL_IN_BG: ILayerConfig;
    readonly SNOW_FALL_IN_FG: ILayerConfig;
    readonly FROZEN_SYMBOL: ILayerConfig;
}

export class BarbarianFuryLayerConfig {
    public static defaultLayerScaleOptions: IDeviceDependentConfig<LayerScaleOption> = {
        desktop: { landscape: LayerScaleOption.REELS_FIT_STAGE },
        mobile: {
            landscape: LayerScaleOption.REELS_FIT_STAGE,
            portrait: LayerScaleOption.REELS_FIT_STAGE
        }
    };

    public static customOptions: CustomLayerScaleOptions = {
        frame: { x: 0, y: 0, width: 720, height: 620 },
        placement: {
            desktop: {
                landscape: { x: 0.5, y: 0.5 }
            },
            mobile: {
                landscape: { x: 0.5, y: 0.5 },
                portrait: { x: 0.5, y: 0.5 }
            }
        },
    };

    public static reelBackground: CustomLayerScaleOptions = {
        target: {
            desktop: {
                landscape: ScaleTarget.STAGE
            },
            mobile: {
                landscape: ScaleTarget.STAGE,
                portrait: ScaleTarget.WINDOW
            }
        },
        placement: {
            desktop: {
                landscape: { x: 0.5, y: 1 }
            },
            mobile: {
                landscape: { x: 0.5, y: 1 },
                portrait: { x: 0.5, y: 1 }
            }
        },
        method: {
            desktop: {
                landscape: ScaleMethod.FIT
            },
            mobile: {
                landscape: ScaleMethod.FIT,
                portrait: ScaleMethod.FIT
            }
        }
    };

    public static introConfig: CustomLayerScaleOptions = {
        target: ScaleTarget.WINDOW,
        method: ScaleMethod.FIT,
        frame: { x: 0, y: 0, width: 720, height: 720 },
        placement: { x: 0.5, y: 0.5 }
    };

    public static BACKGROUND: ILayerConfig = {
        name: "BACKGROUND",
        customOptions: BarbarianFuryLayerConfig.introConfig
    };

    public static REEL_BACKGROUND: ILayerConfig = {
        name: "REEL_BACKGROUND",
        customOptions: BarbarianFuryLayerConfig.reelBackground
    };

    public static REEL_ATTENTION: ILayerConfig = {
        name: "REEL_ATTENTIONS",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static BET_LINES: ILayerConfig = {
        name: "BET_LINES",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static SYMBOLS: ILayerConfig = {
        name: "symbols",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static WIN_PRESENTATIONS: ILayerConfig = {
        name: "WIN_PRESENTATIONS",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static WIN_COUNT_UP: ILayerConfig = {
        name: "WIN_COUNT_UP",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static INTRO: ILayerConfig = {
        name: "intro",
        customOptions: BarbarianFuryLayerConfig.introConfig
    };

    public static BIG_WIN: ILayerConfig = {
        name: "BIG_WIN",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };
    public static BIG_WIN_LABEL: ILayerConfig = {
        name: "BIG_WIN_LABEL",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static SNOW_FALL_IN_BG: ILayerConfig = {
        name: "SNOW_FALL_IN_BG",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static SNOW_FALL_IN_FG: ILayerConfig = {
        name: "SNOW_FALL_IN_FG",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static FROZEN_SYMBOL: ILayerConfig = {
        name: "FROZEN_SYMBOL",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static POP_NUMBERS: ILayerConfig = {
        name: "POP_NUMBERS",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static REEL_FOREGROUND: ILayerConfig = {
        name: "REEL_FOREGROUND",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static FOREGROUND: ILayerConfig = {
        name: "FOREGROUND",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static FREESPINS_LEFT: ILayerConfig = {
        name: "FREESPINS_LEFT",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static MULTIPLIER: ILayerConfig = {
        name: "MULTIPLIER",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static FREESPIN_INTRO: ILayerConfig = {
        name: "FREESPIN_INTRO",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static FREESPIN_OUTRO: ILayerConfig = {
        name: "FREESPIN_OUTRO",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static TWEAK_MODULE: ILayerConfig = {
        name: "TWEAK_MODULE",
        customOptions: BarbarianFuryLayerConfig.customOptions
    };

    public static getConfig(): IBarbarianFuryLayerConfig {
        return {
            BACKGROUND: BarbarianFuryLayerConfig.BACKGROUND,
            SNOW_FALL_IN_BG: BarbarianFuryLayerConfig.SNOW_FALL_IN_BG,
            REEL_BACKGROUND: BarbarianFuryLayerConfig.REEL_BACKGROUND,
            SYMBOLS: BarbarianFuryLayerConfig.SYMBOLS,
            FROZEN_SYMBOL: BarbarianFuryLayerConfig.FROZEN_SYMBOL,
            REEL_FOREGROUND: BarbarianFuryLayerConfig.REEL_FOREGROUND,
            POP_NUMBERS: BarbarianFuryLayerConfig.POP_NUMBERS,
            FOREGROUND: BarbarianFuryLayerConfig.FOREGROUND,
            SNOW_FALL_IN_FG: BarbarianFuryLayerConfig.SNOW_FALL_IN_FG,
            FREESPINS_LEFT: BarbarianFuryLayerConfig.FREESPINS_LEFT,
            MULTIPLIER: BarbarianFuryLayerConfig.MULTIPLIER,
            REEL_ATTENTION: BarbarianFuryLayerConfig.REEL_ATTENTION,
            BET_LINES: BarbarianFuryLayerConfig.BET_LINES,
            WIN_PRESENTATIONS: BarbarianFuryLayerConfig.WIN_PRESENTATIONS,
            INDIVIDUAL_WIN_SYM_COMB:{
                name: "INDIVIDUAL_WIN_SYM_COMB",
                customOptions: BarbarianFuryLayerConfig.customOptions
            },
            BIG_WIN: BarbarianFuryLayerConfig.BIG_WIN,
            BIG_WIN_LABEL: BarbarianFuryLayerConfig.BIG_WIN_LABEL,
            WIN_COUNT_UP: BarbarianFuryLayerConfig.WIN_COUNT_UP,
            FREESPIN_INTRO: BarbarianFuryLayerConfig.FREESPIN_INTRO,
            FREESPIN_OUTRO: BarbarianFuryLayerConfig.FREESPIN_OUTRO,
            INTRO: BarbarianFuryLayerConfig.INTRO,
            TWEAK_MODULE: BarbarianFuryLayerConfig.TWEAK_MODULE
        };
    }
}